import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import { useIntl } from "../hooks"

export default function LogoBar() {
  const { t } = useIntl()
  const data = useStaticQuery(graphql`
    fragment FileFragment on File {
      id
      childImageSharp {
        fluid(maxWidth: 72) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    query {
      alabama: file(relativePath: { eq: "Logos/alabama.png" }) {
        ...FileFragment
      }
      redBull: file(relativePath: { eq: "Logos/redbull-ny.png" }) {
        ...FileFragment
      }
      usaSwimming: file(relativePath: { eq: "Logos/usa-swimming.png" }) {
        ...FileFragment
      }
      atpTour: file(relativePath: { eq: "Logos/atp.png" }) {
        ...FileFragment
      }
      ufc: file(relativePath: { eq: "Logos/ufc.png" }) {
        ...FileFragment
      }
      wta: file(relativePath: { eq: "Logos/wta.png" }) {
        ...FileFragment
      }
      dazn: file(relativePath: { eq: "Logos/dazn.png" }) {
        ...FileFragment
      }
      pbr: file(relativePath: { eq: "Logos/pbr.png" }) {
        ...FileFragment
      }
      pto: file(relativePath: { eq: "Logos/pto-logo.png" }) {
        ...FileFragment
      }
      atlantaUnited: file(relativePath: { eq: "Logos/atlanta-united.png" }) {
        ...FileFragment
      }
      fiba: file(relativePath: { eq: "Logos/fiba.png" }) {
        ...FileFragment
      }
      chicagoFire: file(relativePath: { eq: "Logos/chicago-fire.png" }) {
        ...FileFragment
      }
    }
  `)
  const logos = Object.keys(data)

  return (
    <div className="mb-12 laptop:mb-22 container">
      <div className="mb-6 flex justify-center">
        <h3 className="text-darkGrey text-h6 leading-h6 tracking-12 font-black">{t("Home__BrandRows--Heading")}</h3>
      </div>
      <div className="grid grid-cols-4 laptop:grid-cols-6">
        {logos.map((logo) => (
          <div key={logo} className="flex items-center justify-center">
            <Img fluid={data[logo].childImageSharp.fluid} className="mb-2 h-8 w-8" alt={`${logo} logo`} />
          </div>
        ))}
      </div>
    </div>
  )
}
